module.exports = __webpack_public_path__ + "img/L1070083.37703aa0.jpg";